// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__26DSw","validationTips":"StatementDescriptor_validationTips__28q2h"};